import Audio from '~/Audio';
import Colors from '~/constants/Colors';
import { logError } from '~/logger';
import text from '~/text';
import { GraphQlRequestError } from '~/graphql/graphqlClient';
import { ItemLocationInput } from 'dt-common/generated/graphql-types';
import { HeroBuilds } from 'dt-common/generated/prisma';
import mutationUnequipItem from '~/graphql/game-items/mutationUnequipItem';
import messages, { HeroBuildStoreMessage } from '../messages';

export default async function unequipItem(
  {
    playerId,
    hero_builds,
    setHeroBuilds,
    emit,
  }: {
    playerId: string | null;
    hero_builds: HeroBuilds;
    setHeroBuilds: (builds: HeroBuilds) => void;
    emit: (message: HeroBuildStoreMessage) => void;
  },
  action: { game_item: { uid: string }; from: ItemLocationInput }
) {
  try {
    const result = await mutationUnequipItem({
      playerId: playerId!,
      itemId: action.game_item.uid,
      from: action.from,
    });

    setHeroBuilds({ ...hero_builds, [result.heroHandle]: result.target_hero_builds });
    emit(messages.ITEM_UNEQUIPPED);
    Audio.play('equipment_storage');
  } catch (err) {
    const errorKey = err instanceof GraphQlRequestError ? err.errors?.[0]?.message : undefined;
    if (typeof errorKey === 'string' && text(errorKey)) {
      window.$addMessageLogMessage(text(errorKey), Colors.RED);
    } else {
      window.$addMessageLogMessage(text('server_error'), Colors.RED);
      logError(err, {
        module: 'HeroBuildStore',
        func: 'unequipItem',
        playerId,
        action: JSON.stringify(action),
      });
    }
  }
}
